import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { SecurityService } from "@tylertech/core-module";
import { OnContextEvent } from "./tree";

@Component({
    selector: "metadata-navigation-leaf",
    templateUrl: "./metadataNavigationLeaf.tmpl.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MetadataNavigationLeafComponent implements OnInit
{
    private readonly $securityService = inject(SecurityService);

    @Input()
    public id: string;

    @Input()
    public name: string;

    @Input()
    public disabled: boolean;

    @Input()
    public selected: boolean;

    @Input()
    public hasError: boolean;

    @Output() public onClick = new EventEmitter<string>();

    @Output() public onContextMenu = new EventEmitter<OnContextEvent>();

    public compactMode: boolean = false;

    ngOnInit(): void
    {
        this.compactMode = this.$securityService.IsCompactMode;
    }

    get selectedClass(): Record<string, boolean>
    {
        return { "selected-list-item": !!this.selected };
    }

    navItemKeyup(key: KeyboardEvent): void
    {
        if (key.key === "Enter" || key.key === " ")
        {
            this.fireOnClick();
        }
    }

    fireOnClick(): void
    {
        if (this.disabled)
            return;
        this.onClick.emit(this.id);
    }

    contextMenu(event: MouseEvent): void
    {
        this.onContextMenu.emit({Id: this.id, Event: event});
    }
}
